import { getPublicEnvironmentVariables } from '@module/mdrt-org/shared/utils/helpers/get-public-environment-variables';
import { getStringWithQueryParameters } from '@module/mdrt-org/shared/utils/helpers/get-string-with-query-parameters';
import { fetchWithErrorHandling } from '@module/mdrt-org/shared/utils/http-services/fetch-with-error-handling';

import { type SearchMembersRequest, type SearchMembersResponse } from './types';

export const getMemberDirectorySearchResults = async (
  accessToken?: string,
  requestData?: SearchMembersRequest,
  signal?: AbortSignal
) => {
  const publicEnvironmentVariables =
    typeof window === 'undefined' ? await getPublicEnvironmentVariables() : window.PUBLIC_ENV;

  const urlWithSearchParameters = getStringWithQueryParameters(
    `${publicEnvironmentVariables.apiBaseUrl}/${publicEnvironmentVariables.apiRoute}/SearchMembers`,
    { ...requestData, profilePictureSize: 112 }
  );

  if (!accessToken) {
    throw new Error('Access token or person ID is not available');
  }

  return await fetchWithErrorHandling<SearchMembersResponse>(urlWithSearchParameters, {
    cache: 'no-store',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Ocp-Apim-Subscription-Key': publicEnvironmentVariables.ocpApiSubscriptionKey ?? '',
    },
    signal,
  });
};
